import { EMPTY_OBJECT } from '../../../constants/common'
import { DEFAULT_TIME_ZONE } from '../../../constants/date'
import { PDF_TYPES } from '../../../constants/file'
import { createNowDateInUkTimezone } from '../../../utils/date'
import { generateSentence } from '../../../utils/generate'
import { DocumentsTableCellName } from '../../Document'
import { getTableVisibleColumns } from '../../Table'

const USER_1 = {
  avatar: null,
  avatar_color: '#FFF65F',
  email: 'johndoe@gmail.com',
  fullname: 'John Doe',
  id: 1,
}

const USER_2 = {
  avatar: null,
  avatar_color: '#ACC81F',
  fullname: 'Zigmund Freid',
  id: 2,
}

export const TABLE_ROW_COLUMNS_CONFIG = {
  [DocumentsTableCellName.Access]: {
    index: 0,
    name: DocumentsTableCellName.Access,
    ordering_field: null,
    title: 'Documents.AccessColumnTitleKey',
    visible: true,
    width: 252,
  },
  [DocumentsTableCellName.CreatedAt]: {
    index: 0,
    name: DocumentsTableCellName.CreatedAt,
    ordering_field: null,
    title: 'Documents.CreatedAtColumnTitleKey',
    visible: true,
    width: 200,
  },
  [DocumentsTableCellName.CreatedBy]: {
    index: 0,
    name: DocumentsTableCellName.CreatedBy,
    ordering_field: null,
    title: 'Documents.CreatedByColumnTitleKey',
    visible: true,
    width: 252,
  },
  [DocumentsTableCellName.Size]: {
    index: 0,
    name: DocumentsTableCellName.Size,
    ordering_field: null,
    title: 'Documents.SizeColumnTitleKey',
    visible: true,
    width: 100,
  },
  [DocumentsTableCellName.Title]: {
    index: 0,
    name: DocumentsTableCellName.Title,
    ordering_field: null,
    title: 'Documents.TitleColumnTitleKey',
    visible: true,
    width: 252,
  },
  [DocumentsTableCellName.Type]: {
    index: 0,
    name: DocumentsTableCellName.Type,
    ordering_field: null,
    title: 'Documents.TypeColumnTitleKey',
    visible: true,
    width: 100,
  },
  [DocumentsTableCellName.Updated]: {
    index: 0,
    name: DocumentsTableCellName.Updated,
    ordering_field: null,
    title: 'Documents.UpdatedColumnTitleKey',
    visible: true,
    width: 200,
  },
  [DocumentsTableCellName.UpdatedBy]: {
    index: 0,
    name: DocumentsTableCellName.UpdatedBy,
    ordering_field: null,
    title: 'Documents.UpdatedByColumnTitleKey',
    visible: true,
    width: 200,
  },
}

export const TABLE_ROW_VISIBLE_COLUMNS = getTableVisibleColumns(
  TABLE_ROW_COLUMNS_CONFIG
)

export function getTableRowData(data) {
  const now = createNowDateInUkTimezone(DEFAULT_TIME_ZONE).toISOString()

  const {
    created = now,
    created_by = USER_1,
    size = 1000000,
    title = generateSentence(3, 5),
    type = PDF_TYPES[0],
    updated = now,
    updated_by = USER_2,
  } = data || EMPTY_OBJECT

  return {
    [DocumentsTableCellName.Access]: 'Public',
    [DocumentsTableCellName.CreatedAt]: created,
    [DocumentsTableCellName.CreatedBy]: created_by,
    [DocumentsTableCellName.Size]: size,
    [DocumentsTableCellName.Title]: title,
    [DocumentsTableCellName.Type]: type,
    [DocumentsTableCellName.Updated]: updated,
    [DocumentsTableCellName.UpdatedBy]: updated_by,
  }
}
